import React from 'react';
import PropTypes from 'prop-types';
import ReactJson from 'react-json-view'

import { getUserRoleFromJWT } from '../../helpers';

export default class ExpandJsonView extends React.Component {
  static contextTypes = {
    router: PropTypes.object
  };
  constructor(props, context) {
    super(props, context);
    this.state = {
      currentUserRole: getUserRoleFromJWT()
    };
  }
  componentDidMount() {}

  render() {
    return (
      <div style={{ maxWidth: '100em', minWidth: '40em', maxHeight: '100%', fontSize: '20px' }}>
        <ReactJson 
          name={this.props.name}
          src={this.props.config}
          theme='monokai'
          onAdd={this.state.currentUserRole === 'admin' ? this.props.onAdd : false}
          onEdit={this.state.currentUserRole === 'admin' ? this.props.onEdit : false}
          onDelete={this.state.currentUserRole === 'admin' ? this.props.onDelete : false}
          enableClipboard={this.state.currentUserRole === 'admin' ? this.props.enableClipboard : false}
        />
      </div>
    );
  }
}
